import BusinessNoteDetailModal from './business-note-detail-modal.vue'
export default BusinessNoteDetailModal
